import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DemoService } from 'src/app/demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import { GlobalFunctionsService } from 'src/app/services/global-functions.service';
import { SystemNotice } from 'src/app/shared/models/systemNotice.model';

@Component({
  selector: 'app-system-notice-update',
  templateUrl: './system-notice-update.component.html',
  styleUrls: ['./system-notice-update.component.scss']
})
export class SystemNoticeUpdateComponent implements OnInit {
  model: SystemNotice;
  brands: any[] = [];
  users: any;
  user_levels: any;

  notice_id: number;
  cValue: any;

  @Input('value')
      set value(value: any) {
          this.cValue = value;
      }
  
      @Input('brandForm') brandForm: any;


      

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private _demoService: DemoService,
    public gfunc: GlobalFunctionsService,
    public toastr: HotToastService
  ) {}

  ngOnInit(): void {
    this.notice_id = +this.route.snapshot.paramMap.get('id');
    this.model = new SystemNotice();

    

    this.getBrands();
    this.getUsers();
    this.getUserLevels();
    this.getNoticeById(this.notice_id);
  }

  getNoticeById(id: number) {
    this._demoService.getSystemNotice(id).subscribe((res: any) => {
      this.model = res[0];

        this.model.show_on_login = this.model.show_on_login == 1;
        this.model.show_as_modal = this.model.show_as_modal == 1;
        this.model.active = this.model.active == 1;

        this.model.show_to_tfa_user = this.model.show_to_tfa_user == 1;
        this.model.show_on_logout = this.model.show_on_logout == 1;
        

      // convert string to array for multiselect
      if (typeof this.model.show_to_brands === 'string') {
        this.model.show_to_brands = this.model.show_to_brands.split(',').map(id => +id);
      }
      if (typeof this.model.show_to_users === 'string') {
        this.model.show_to_users = this.model.show_to_users.split(',').map(id => +id);
      }
    });
  }

  updateSystemNotice(model) {
    model.show_to_brands = (model.show_to_brands || []).join(',');
    model.show_to_users = (model.show_to_users || []).join(',');
    model.show_on_login = model.show_on_login ? 1 : 0;
    model.show_as_modal = model.show_as_modal ? 1 : 0;
    model.active = model.active ? 1 : 0;

    this.model.show_to_tfa_user = this.model.show_to_tfa_user ? 1 : 0;
    this.model.show_on_logout = this.model.show_on_logout ? 1 : 0;

    this._demoService.updateSystemNotice(this.notice_id, model).subscribe(
      res => {
        this.toastr.success('System Notice updated successfully.');
        this.gfunc.globalSystemNoticesSkipRoute();
      },
      err => this.toastr.error('Update failed. Please try again.')
    );
  }

  private getBrands() {
    this._demoService.getBrands().subscribe(res => (this.brands = res));
  }

  private getUsers() {
    this._demoService.getUsers().subscribe(res => (this.users = res));
  }

  private getUserLevels() {
    this._demoService.getUserLevels().subscribe(res => (this.user_levels = res));
  }



  setColour(value2){
    console.log('SetColour: ' + value2)
    this.brandForm.colour.value = this.brandForm.colourpicker.value
  }



}
